export default __webpack_public_path__ + "static/media/Wolf's Armbands of the Covert Trail.b91a1e75.jpg";